import { axiosInstance } from '../../utils/axios-instance'

const state = () => ({
  slides: []
})

const mutations = {
  addFavourite (state, favourite) {
    state.slides.push(favourite)
  },
  concatFavourites (state, favourites) {
    state.slides = state.slides.concat(favourites)
  },
  removeFavourite (state, favouriteId) {
    state.slides = state.slides.filter(favourite => favourite.id !== favouriteId)
  }
}

const getters = {
  isFavourite: (state) => (slideId) => {
    return state.slides.find(favourite => favourite.slide === slideId) !== undefined
  },
  getFavourite: (state) => (slideId) => {
    return state.slides.find(favourite => favourite.slide === slideId)
  }
}

const actions = {
  async fetchFavourites ({ commit }) {
    let next = true
    let page = 1
    while (next) {
      const response = await axiosInstance.get('/favourite_slides/', { params: { page: page++ } })
      next = response.data.next
      commit('concatFavourites', response.data.results)
    }
  },
  async toggleFavourite ({ getters, state, commit, rootState }, { slide, gtag }) {
    if (getters.isFavourite(slide.id)) {
      const favourite = getters.getFavourite(slide.id)
      await axiosInstance.delete(`/favourite_slides/${favourite.id}/`)
      commit('removeFavourite', favourite.id)
      if (rootState.filtering.favourites) {
        commit('panel/removeSlide', slide.id, { root: true })
      }
      gtag.event(
        'favourite_remove',
        {
          event_category: 'engagement',
          event_label: slide.title
        }
      )
    } else {
      const response = await axiosInstance.post('/favourite_slides/', { slide: slide.id })
      commit('addFavourite', response.data)
      gtag.event(
        'favourite_add',
        {
          event_category: 'engagement',
          event_label: slide.title
        }
      )
    }
  }
}

export default { namespaced: true, state, mutations, getters, actions }
